import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'cc-lg-position-box',
  templateUrl: './position-box.component.html',
  styleUrls: ['./position-box.component.scss']
})
export class PositionBoxComponent implements OnInit {
  @Input() positionSettings: FormGroup;

  public alignment_options = ['RIGHT', 'LEFT'];

  constructor() {}

  ngOnInit() {}

  get useDefault() {
    return this.positionSettings.controls.useDefault.value;
  }

  changeUseDefault(useDefault) {
    this.positionSettings.controls.useDefault.setValue(!useDefault);
  }
}
